const units = {}

units["bomber"] = {
    "skills": ["bomb-throw"],
    "name": "Bomber",
    "maxhealth": 3,
    "moverange": 4,
    "affiliation": "bad",
    "images": {
        "sprites": {
            "static": require("@frog/source/assets/images/bomber-tactics/units/enemy/p-ready-bomb enem/p-ready-bomb enem1_.png").default,
            // "idle": require("@frog/source/assets/images/bomber-tactics/units/enemy/p-ready-bomb enem/animation.js"),
            "attack": require("@frog/source/assets/images/bomber-tactics/units/enemy/p-launch-bomb enem/animation.js").frames,
            // "move": require("@frog/source/assets/images/bomber-tactics/units/enemy/p-walk-bomb enem/animation.js").frames,
            "pushed": require("@frog/source/assets/images/bomber-tactics/units/enemy/p-push-bomb enem/animation.js").frames,
            "death": require("@frog/source/assets/images/bomber-tactics/units/enemy/p-death-bomb enem/animation.js").frames,
        }
    },
}

units["red-bomber"] = {
    "skills": ["gun-push"], //, "bomb-throw"],
    // "skills": [],
    "name": "Sniper",
    "maxhealth": 3,
    "moverange": 4,
    "index": 1,
    "affiliation": "good",
    "images": {
        "sprites": {
            "static": require("@frog/source/assets/images/bomber-tactics/units/red/ready/1_.png").default,
            // "idle": require("@frog/source/assets/images/bomber-tactics/units/red/ready/animation.js"),
            "attack": require("@frog/source/assets/images/bomber-tactics/units/red/launch/animation.js").frames,
            // "move": require("@frog/source/assets/images/bomber-tactics/units/red/walk/animation.js").frames,
            "pushed": require("@frog/source/assets/images/bomber-tactics/units/red/push/animation.js").frames,
            "death": require("@frog/source/assets/images/bomber-tactics/units/red/death/animation.js").frames,
        }
    },
}

units["blue-bomber"] = {
    "skills": ["gun-pull"],
    // "skills": [],
    "name": "Pistol",
    "maxhealth": 3,
    "moverange": 4,
    "index": 2,
    "affiliation": "good",
    "images": {
        "sprites": {
            "static": require("@frog/source/assets/images/bomber-tactics/units/blue/p-ready-blue/p-ready-blue1_.png").default,
            // "idle": require("@frog/source/assets/images/bomber-tactics/units/blue/p-ready-blue/animation.js"),
            "attack": require("@frog/source/assets/images/bomber-tactics/units/blue/p-launch-blue/animation.js").frames,
            // "move": require("@frog/source/assets/images/bomber-tactics/units/blue/p-walk-blue/animation.js").frames,
            "pushed": require("@frog/source/assets/images/bomber-tactics/units/blue/p-push-blue/animation.js").frames,
            "death": require("@frog/source/assets/images/bomber-tactics/units/blue/p-death-blue/animation.js").frames,
        }
    },
}

units["yellow-bomber"] = {
    "skills": ["gun-burst"],
    // "skills": [],
    "name": "Shotgun",
    "maxhealth": 3,
    "moverange": 4,
    "index": 3,
    "affiliation": "good",
    "images": {
        "sprites": {
            "static": require("@frog/source/assets/images/bomber-tactics/units/yellow/p-ready-yellow/p-ready-yellow1_.png").default,
            // "idle": require("@frog/source/assets/images/bomber-tactics/units/yellow/p-ready-yellow/animation.js"),
            "attack": require("@frog/source/assets/images/bomber-tactics/units/yellow/p-launch-yellow/animation.js").frames,
            // "move": require("@frog/source/assets/images/bomber-tactics/units/yellow/p-walk-yellow/animation.js").frames,
            "pushed": require("@frog/source/assets/images/bomber-tactics/units/yellow/p-push-yellow/animation.js").frames,
            "death": require("@frog/source/assets/images/bomber-tactics/units/yellow/p-death-yellow/animation.js").frames,
        }
    },
}

units["bomb"] = {
    "skills": ["explode"],
    "name": "Bomb",
    "maxhealth": 1,
    "moverange": 0,
    "class": "bomb",
    "affiliation": "none",
    "images": {
        "sprites": {
            "static": require("@frog/source/assets/images/bomber-tactics/bomb/bomb01.png").default,
            "idle": require("@frog/source/assets/images/bomber-tactics/bomb/animation.js"),
        }
    },
}

units["egg"] = {
    "skills": [],
    "name": "Egg",
    "maxhealth": 1,
    "moverange": 0,
    "class": "egg",
    "affiliation": "none",
    "images": {
        "sprites": {
            // "static": require("@frog/source/assets/images/bomber-tactics/units/egg_.png").default,
            "idle": require("@frog/source/assets/images/bomber-tactics/units/egg/animation.js"),
        }
    },
}

units["wall"] = {
    "skills": [],
    "name": "Wall",
    "maxhealth": 1,
    "moverange": 0,
    "class": "wall",
    "affiliation": "none",
    "images": {
        "sprites": {
            // "static": require("@frog/source/assets/images/bomber-tactics/tiles/tiles-lowrezjam/40_static-double-pipe.png").default,
            "idle": require("@frog/source/assets/images/bomber-tactics/units/tubes/animation.js"),
        }
    },
}

export default units

function getAnimationFrames(context) {
    const frames = context.keys().map((key) => ({"key": key, "image": context(key).default}))
    frames.forEach((frame) => {
        frame.value = frame.image // backwards compatability
        const numbers = frame.key.match(/([0-9]+)/)
        frame.time = Number.parseInt(numbers[0] || NaN) * 100 // IN MILLISECONDS
        frame.index = numbers[0]
    })
    frames.sort((a, b) => {
        return a.time - b.time
    })
    return frames
}
